import { useEffect } from "react";

const LANGUAGES = [
  { code: "en", locale: "en_US" },
  { code: "zh-CN", locale: "zh_CN" },
  { code: "zh-TW", locale: "zh_TW" },
  { code: "ja", locale: "ja_JP" },
  { code: "ko", locale: "ko_KR" },
];

export const HreflangTags: React.FC = () => {
  useEffect(() => {
    // Remove existing hreflang tags
    document
      .querySelectorAll('link[rel="alternate"][hreflang]')
      .forEach((el) => el.remove());

    // Add hreflang tags for each language
    LANGUAGES.forEach((lang) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = lang.locale;
      link.href = `https://bricksup.com/${
        lang.code === "en" ? "" : lang.code
      }`;
      document.head.appendChild(link);
    });

    // Add x-default for language negotiation
    const xDefault = document.createElement("link");
    xDefault.rel = "alternate";
    xDefault.hreflang = "x-default";
    xDefault.href = "https://bricksup.com/";
    document.head.appendChild(xDefault);
  }, []);

  return null;
};
